import { AutogenModelBreakthroughHistory, AutogenRowBreakthroughHistory } from "./autogen/AutogenModelBreakthroughHistory";

export class ModelBreakthroughHistory extends AutogenModelBreakthroughHistory<RowBreakthroughHistory> {
	constructor() {
		super(RowBreakthroughHistory);
	}
}

export class RowBreakthroughHistory extends AutogenRowBreakthroughHistory {
}